export default __webpack_public_path__ + "static/media/bannerBig2.9b9a0a70.png";